import { t } from "i18next"

import { SpecialityAttributeKeys } from "@/types/educators/speciality"

export function createAttributeOptions(
  translationPrefix:
    | "specialities:attributes"
    | "search:select_attributes" = "specialities:attributes",
): Array<{
  value: SpecialityAttributeKeys | "learning_style_description"
  label: string
  group: string
}> {
  return [
    {
      label: t(`${translationPrefix}.religion.label`),
      value: "speciality_religions",
      group: t(`${translationPrefix}.religion.group`),
    },
    {
      label: t(`${translationPrefix}.gender.label`),
      value: "speciality_genders",
      group: t(`${translationPrefix}.gender.group`),
    },
    {
      label: t(`${translationPrefix}.languages.primary.label`),
      value: "speciality_primary_languages",
      group: t(`${translationPrefix}.languages.group`),
    },
    {
      label: t(`${translationPrefix}.languages.secondary.label`),
      value: "speciality_secondary_languages",
      group: t(`${translationPrefix}.languages.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.qualitative.label`),
      value: "overall_qualitative_assessment",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.subject_grade.label`),
      value: "subject_grade_range",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.naplan.label`),
      value: "naplan_score",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.wisc_v.label`),
      value: "wisc_v",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.wiat_iv.label`),
      value: "wiat_iv",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.wais_iv.label`),
      value: "wais_iv",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.intellectual_ability.aeas.label`),
      value: "aeas",
      group: t(`${translationPrefix}.intellectual_ability.group`),
    },
    {
      label: t(`${translationPrefix}.parent_socio_economic.label`),
      value: "parent_socio_economic",
      group: t(`${translationPrefix}.parent_socio_economic.group`),
    },
    {
      label: t(`${translationPrefix}.learning_styles.description.label`),
      value: "learning_style_description",
      group: t(`${translationPrefix}.learning_styles.group`),
    },
    {
      label: t(`${translationPrefix}.learning_styles.vark.label`),
      value: "learning_style_vark",
      group: t(`${translationPrefix}.learning_styles.group`),
    },
    {
      label: t(`${translationPrefix}.learning_styles.gardner.label`),
      value: "learning_style_gardner",
      group: t(`${translationPrefix}.learning_styles.group`),
    },
    {
      label: t(`${translationPrefix}.learning_styles.kolb.label`),
      value: "learning_style_kolb",
      group: t(`${translationPrefix}.learning_styles.group`),
    },
    {
      label: t(`${translationPrefix}.learning_preferences.label`),
      value: "learning_preference",
      group: t(`${translationPrefix}.learning_preferences.group`),
    },
    {
      label: t(`${translationPrefix}.other_information.eyesight.label`),
      value: "eyesight",
      group: t(`${translationPrefix}.other_information.group`),
    },
    {
      label: t(`${translationPrefix}.other_information.adhd.label`),
      value: "adhd",
      group: t(`${translationPrefix}.other_information.group`),
    },
    {
      label: t(`${translationPrefix}.other_information.autism.label`),
      value: "autism",
      group: t(`${translationPrefix}.other_information.group`),
    },
    {
      label: t(`${translationPrefix}.other_information.depression.label`),
      value: "depression",
      group: t(`${translationPrefix}.other_information.group`),
    },
    {
      label: t(`${translationPrefix}.student_socio_economic.label`),
      value: "student_socio_economic",
      group: t(`${translationPrefix}.student_socio_economic.group`),
    },
  ]
}
